import React from "react";
import PageHero from "@/components/PageHero";
import ProductCatalog from "@/components/ProductCatalog";
import QuoteCTA from "@/components/QuoteCTA";
import { Reveal } from "@/components/Reveal";

const specs = [
  { k: "Twin-Tank", v: "Continuous soft water — one tank regenerates while the other serves." },
  { k: "Non-Electric", v: "Powered by the movement of water itself. No timers. No plugs." },
  { k: "On-Demand", v: "Regenerates based on actual usage, not the calendar. Zero waste cycles." },
  { k: "Warrantied", v: "Kinetico backs its systems with an industry-leading 10-year warranty." },
];

export default function Products() {
  return (
    <div data-testid="products-page">
      <PageHero
        eyebrow="Products"
        title="Every water problem,"
        italic="matched."
        description="Kinetico builds the industry's widest lineup of water systems — from compact residential softeners to municipal-scale treatment. Explore by category below."
        testId="products-hero"
      />

      <ProductCatalog />

      <section className="py-32 lg:py-40 px-6 lg:px-10 border-t border-[color:var(--border)]">
        <div className="mx-auto max-w-[1400px]">
          <div className="grid grid-cols-12 gap-6 lg:gap-10 mb-16">
            <div className="col-span-12 lg:col-span-4">
              <div className="text-[11px] uppercase tracking-[0.35em] text-[color:var(--blue)]">
                Why Kinetico
              </div>
              <Reveal>
                <h2 className="mt-4 font-display font-semibold text-[clamp(2rem,5vw,4rem)] leading-[0.95] text-white">
                  Four things<br />
                  <span className="font-editorial italic font-normal text-[color:var(--blue)]">
                    that matter.
                  </span>
                </h2>
              </Reveal>
            </div>
            <div className="col-span-12 lg:col-span-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-y-12 gap-x-10">
                {specs.map((s, i) => (
                  <Reveal
                    key={s.k}
                    delay={i * 0.05}
                    testId={`spec-${i}`}
                  >
                    <div className="text-[color:var(--green)] font-display text-4xl font-black tabular">
                      {String(i + 1).padStart(2, "0")}
                    </div>
                    <div className="mt-4 font-display font-semibold text-2xl text-white">{s.k}</div>
                    <p className="mt-2 text-[14.5px] leading-[1.7] text-[color:var(--muted)] font-body">
                      {s.v}
                    </p>
                  </Reveal>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <QuoteCTA />
    </div>
  );
}
